import { v4 as generateGUID } from 'uuid';
import { HLF_SESSION, HLF_IDENTITY } from '@client/definitions/constants.js';

export const session = (cookies) => {
  return {
    session: cookies.get(HLF_SESSION)
      ? cookies.get(HLF_SESSION)
      : generateGUID(),
    identity: cookies.get(HLF_IDENTITY)
      ? cookies.get(HLF_IDENTITY)
      : generateGUID(),
    currentUrl: typeof window !== 'undefined' && window.location.href,
    requestgroup: generateGUID(),
  };
};
